import { useEffect } from "react";
import { useAuthentication } from "@aviv-unified-frontend/runtime/authentication";
import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useOverlayStepsOrchestrator } from "../../useOverlayStepsOrchestrator";
import { BRAND_CONFIGURATION } from "../../../../../configs/brands";
import { KEY } from "./constants";
const { googleOneTap } = BRAND_CONFIGURATION.authentication ?? {};
export const useInitGoogleOneTap = () => {
    const { dispatch } = useOverlayOrchestrator();
    const canProceed = useOverlayStepsOrchestrator(KEY);
    const { state } = useAuthentication();
    const isPending = state === "pending";
    const isActive = Boolean(googleOneTap && ["unauthenticated", "error"].includes(state));
    useEffect(() => {
        if (!canProceed || isPending)
            return;
        const type = isActive ? "INIT" : "DISABLE";
        dispatch({ type, payload: KEY });
    }, [canProceed, isActive, isPending, dispatch]);
};
